// Update unit price on variant change
document.addEventListener('DOMContentLoaded', function() {
  var variantSelects = document.querySelectorAll('[name="id"]');
  
  variantSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      var variantId = this.value;
      updateUnitPrice(variantId);
    });
  });
  
  function updateUnitPrice(variantId) {
    fetch(window.location.pathname + '.js')
      .then(response => response.json())
      .then(product => {
        var variant = product.variants.find(v => v.id == variantId);
        var unitPriceContainer = document.querySelector('.product-unit-price[data-unit-price]');
        
        if (variant && variant.unit_price_measurement && unitPriceContainer) {
          var unitPrice = formatMoney(variant.unit_price);
          var unitPriceAmount = unitPriceContainer.querySelector('[data-unit-price-amount]');
          
          if (unitPriceAmount) {
            unitPriceAmount.textContent = unitPrice;
          }
          unitPriceContainer.style.display = 'block';
        } else if (unitPriceContainer) {
          unitPriceContainer.style.display = 'none';
        }
      });
  }
  
  function formatMoney(cents) {
    var price = (cents / 100).toFixed(2);
    return 'Rs. ' + price;
  }
});
